export enum WebSocketAnalyticsEvents {
  UnexpectedClosure = 'unexpected_closure',
  NormalClosure = 'normal_closure',
}
